import * as z from 'zod';

const accessLevelZod = z.object({
  name: z.string(),
  value: z.enum(['', 'Admin', 'Anyone Logged In', 'Login Not Required']),
});

type TAccessLevel = z.infer<typeof accessLevelZod>;

const defaultStatus: TAccessLevel = { name: 'None', value: '' };

export const accessLevelOptions: TAccessLevel[] = [
  defaultStatus,
  { name: 'Admin', value: 'Admin' },
  { name: 'Anyone Logged In', value: 'Anyone Logged In' },
  { name: 'Login Not Required', value: 'Login Not Required' },
];

export function accessLevelSchema() {
  return accessLevelZod.refine(({ value }) => value !== '', {
    message: "Access Level can't be None",
  });
}

export function strToAccessLevel(str: string): TAccessLevel {
  return accessLevelOptions.find((item) => item.value === str) ?? defaultStatus;
}
